export default __webpack_public_path__ + "static/media/IconDesc_TurboFuel.64.055b2835.png";